import { fetch } from '@maxtropy/components';

export function getDefaultLogoKey(): Promise<{ key: string }> {
  return fetch('/api/file-center/getDefaultLogoKey');
}
